/* eslint-disable radix */
import Swiper from 'swiper';
import BaseFeature from '../../foundation/base/base';

class ContentSwipe extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;

		this.log('Swiper');

		const DefaultBreakpoints = {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			480: {
				slidesPerView: 1,
				spaceBetween: 20,
			}
		};

		this.numberOfPages = this.el.querySelectorAll('[data-swiper-slide]').length || 0;

		// Here we can import values from Sitecore through the data-config attribute
		this.config = this.el.getAttribute('data-config');
		this.config = JSON.parse(this.config);

		// Swiper configuration
		// Do you need to enhance? go to api: https://idangero.us/swiper/api/

		this.swiperConfig = {
			// Example of data-config use. If not present we set a default
			spaceBetween: this.config.spaceBetween !== undefined ? parseInt(this.config.spaceBetween)
				: 30,
			grabCursor: true,
			slidesPerView: this.config.slidesPerView ? parseInt(this.config.slidesPerView) : 1,
			/* navigation: {
				nextEl: '[swiper-button-next]',
				prevEl: '[swiper-button-prev]',
			}, */
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			autoplay: this.config.autoplay ? this.config.autoplay : false,
			breakpoints: this.config.breakpoints ? this.config.breakpoints : DefaultBreakpoints
		};
		this.initEvents();
	}


	initEvents() {
		if ((this.swiper === undefined || this.swiper.destroyed === true) && this.numberOfPages > 1) {
			this.activateSwipe();
		} else {
			this.removeSwipe();
		}
	}

	activateSwipe() {
		this.swiper = new Swiper(this.dom.swiperContainer, this.swiperConfig);
	}

	removeSwipe() {
		if (this.swiper !== undefined) this.swiper.destroy(true, true);
	}
}

export default ContentSwipe;
